var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1295 9.50065L17.1882 15.7837C17.5883 16.1987 17.5343 16.8234 17.0675 17.1791C16.6006 17.5347 15.8978 17.4867 15.4977 17.0717L8.818 10.1447C8.46065 9.77407 8.46065 9.22723 8.818 8.85664L15.4977 1.92957C15.8978 1.51462 16.6006 1.46656 17.0675 1.82224C17.5343 2.17791 17.5883 2.80264 17.1882 3.21759L11.1295 9.50065Z",
    fill: "#004343"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.87046 9.50065L1.8118 15.7837C1.41166 16.1987 1.46572 16.8234 1.93255 17.1791C2.39938 17.5347 3.10219 17.4867 3.50233 17.0717L10.182 10.1447C10.5394 9.77407 10.5394 9.22723 10.182 8.85664L3.50233 1.92957C3.10219 1.51462 2.39938 1.46656 1.93255 1.82224C1.46572 2.17791 1.41166 2.80264 1.8118 3.21759L7.87046 9.50065Z",
    fill: "#004343"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.34603447652ab9bf581f458f69f760b4.svg";
export { ForwardRef as ReactComponent };